// Isi Massal Rotasi Klinik -- fungsi murni. Batas peserta & semua aturan dari server (aturan_rotasi di
// GET /rotasi-klinik/monitoring; ditegakkan lagi di POST /rotasi-klinik/isi-massal[/pratinjau]).
import { badanSimpan } from "@/lib/rotasiCepat";

// Status tombol "Isi Massal" utk jumlah peserta terpilih.
export function statusPilihan(jumlah, maks) {
    if (jumlah === 0) return { bisa: false, pesan: null };
    if (maks && jumlah > maks) {
        return { bisa: false, pesan: `Isi Massal maksimal ${maks} peserta sekali simpan (terpilih ${jumlah}). Kurangi pilihan.` };
    }
    return { bisa: true, pesan: null };
}

// Pilihan disimpan sbg Map id -> {id, nama, npm} (tetap utuh saat pindah halaman). Selalu objek baru.
export function togglePilih(pilihan, peserta) {
    const baru = new Map(pilihan);
    if (baru.has(peserta.id)) baru.delete(peserta.id);
    else baru.set(peserta.id, { id: peserta.id, nama: peserta.nama, npm: peserta.npm });
    return baru;
}

export function pilihSemuaTampil(pilihan, daftar, nyala) {
    const baru = new Map(pilihan);
    daftar.forEach((p) => (nyala ? baru.set(p.id, { id: p.id, nama: p.nama, npm: p.npm }) : baru.delete(p.id)));
    return baru;
}

export const semuaTampilTerpilih = (pilihan, daftar) => daftar.length > 0 && daftar.every((p) => pilihan.has(p.id));

// Badan request Isi Massal: baris sama dgn panel (badanSimpan) + daftar peserta.
export function badanIsiMassal(form, pesertaIds, bulan, tahun) {
    const { peserta_id: _abaikan, cek_saja: _cek, ...isi } = badanSimpan(form, null, bulan, tahun);
    return { ...isi, peserta_ids: [...pesertaIds] };
}

export function statusPeserta(h) {
    if (h.galat?.length) return "galat";
    if (h.peringatan?.length) return "peringatan";
    return "aman";
}

export function ringkasPratinjau(hasil) {
    const r = { aman: 0, peringatan: 0, galat: 0 };
    (hasil || []).forEach((h) => { r[statusPeserta(h)] += 1; });
    return r;
}

// Penolakan simpan (400 detail.peserta [{peserta_id, alasan}]) digabung ke hasil pratinjau yg tampil.
export function gabungPenolakan(hasil, ditolak) {
    const alasan = new Map((ditolak || []).map((d) => [d.peserta_id, d.alasan]));
    return (hasil || []).map((h) => (alasan.has(h.peserta_id) ? { ...h, galat: alasan.get(h.peserta_id) } : h));
}
